<template>
	<div class="Carousel">
		<slider 
			animation="fade"
			:height="clientHeight"
			:touch="true"
			:control-btn="true"
			:interval="4000"
			:indicators="'center'"
		>
			<slider-item 
				v-for="pictureID in pictureIDs" 
				:key="pictureID"
			>
				<img 
					:src="require(`@/assets/images/carousel/${pictureID}.jpg`)" 
					:alt="`${pictureID}`"
					:style="{ 'height': clientHeight }"
				>
			</slider-item>
		</slider>
	</div>
</template>

<script>
import { Slider, SliderItem } from 'vue-easy-slider'

export default {
	name: 'Carousel',
	components: {
		Slider,
		SliderItem
	},
	data() {
		return {
			pictureIDs: [1, 2, 3, 4, 5],
			clientHeight: '0'
		};
	},
	created() {
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		handleResize() {
			let width = window.innerWidth, height= window.innerHeight

			if(width < 768) {
				this.clientHeight = '142px'
			} else if(width >= 768 && width < 1024) {
				this.clientHeight = '292px'
			} else if(width >= 1024 && width < 1440) {
				this.clientHeight = '389px'
			} else if(width >= 1440 && width < 1920) {
				this.clientHeight = '547px'
			} else if(width >= 1920) {
				this.clientHeight = '730px'
			}

		}
	}
};
</script>

<style lang="scss" scoped>
.Carousel {
	img {
		// height: 300px;
		width: 100%;
	}
}

/deep/ {
	.slider {
		z-index: 1 !important;
	}

	.slider-indicators,
	.slider-indicators-center {
		bottom: 10px !important;
	}

	.slider-indicator-icon {
		margin: 0 5px !important;
	}
}
</style>
